var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndrawSignHereLxua(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 646.327,
    height: 800,
    viewBox: "0 0 646.327 800",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-637 -140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.4.164V17.688S13.2,25.317.419,21.185c0,0-5.239-8.875,21.331-10.295C21.755,10.89,104.453-1.559,131.4.164Z",
    transform: "matrix(-0.978, -0.208, 0.208, -0.978, 1039.104, 550.126)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(958.419 209.669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M550.009,624.357a2.437,2.437,0,0,1-.256-.006H305.613a14.382,14.382,0,0,1-13.379-19.71c8.858-22.132,20.785-75.229,1.142-182.186-23.2-126.3-2.429-171.941,7.576-185.7a14.445,14.445,0,0,1,11.65-5.931H560.564A14.386,14.386,0,0,1,574.4,249.191C564.056,284.958,542.753,379.728,568.294,487c19.362,81.323,10.055,114.493-1.163,128C559.731,623.906,551.578,624.357,550.009,624.357ZM312.6,233.273a11.992,11.992,0,0,0-9.67,4.922c-9.82,13.507-30.175,58.457-7.148,183.822,18.763,102.175,9.665,156.2-1.275,183.538a11.735,11.735,0,0,0,1.2,11.095,11.951,11.951,0,0,0,9.908,5.256h244.2c.386.019,8.258.237,15.51-8.566,10.808-13.116,19.684-45.583.589-125.777-25.675-107.833-4.261-203.1,6.137-239.05a11.938,11.938,0,0,0-11.486-15.242Z",
    transform: "translate(-282.807 -230.822)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.06,324.41H512.684a9.792,9.792,0,1,0,0-19.585H318.06a9.792,9.792,0,1,0,0,19.585Z",
    transform: "translate(-267.026 -214.244)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.06,358.41H512.684a9.792,9.792,0,1,0,0-19.585H318.06a9.792,9.792,0,1,0,0,19.585Z",
    transform: "translate(-267.026 -206.626)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.06,290.41h91.8a9.792,9.792,0,1,0,0-19.585h-91.8a9.792,9.792,0,1,0,0,19.585Z",
    transform: "translate(-267.026 -221.861)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.715,517.309c-1.976-8.366-11.258-11.109-18.845-10.8a80.456,80.456,0,0,0-14.212,2.249c-4.877,1.091-9.708,2.383-14.511,3.753-8.811,2.513-17.532,5.551-26.488,7.517-7.456,1.632-15.559,2.6-22.995.337-7.148-2.171-13.212-7.5-15.156-14.865-1.832-6.942.684-14.533,7.411-17.7,6.135-2.893,13.883-1.422,16.925,5.121,3.426,7.377,0,15.419-5.426,20.76a60.8,60.8,0,0,1-10.083,7.659,37.551,37.551,0,0,1-12.074,5.408c-7.081,1.512-15.517-.716-19.171-7.482a12.644,12.644,0,0,1-1.434-4.941c-.216-2.353,3.457-2.337,3.671,0,.619,6.736,8.508,9.891,14.408,9.152a29.289,29.289,0,0,0,11.17-4.335,65.458,65.458,0,0,0,9.252-6.526c5-4.33,9.694-11.456,6.334-18.213-2.736-5.5-9.871-5.447-14.209-1.9-5.255,4.3-4.317,12.1-.852,17.2,3.834,5.65,10.792,8.019,17.35,8.275,7.125.277,14.2-1.357,21-3.291,8.461-2.4,16.838-5.092,25.34-7.354,4.827-1.284,9.691-2.443,14.6-3.345A48.2,48.2,0,0,1,500.884,503c7.663.885,15.484,5.345,17.371,13.335.543,2.3-3,3.279-3.541.979Z",
    transform: "translate(-300.132 -190.405)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.06,358.41H512.684a9.792,9.792,0,1,0,0-19.585H318.06a9.792,9.792,0,1,0,0,19.585Z",
    transform: "translate(-267.026 -165.008)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.254,358.41H454.112c3.859,0,6.987-4.384,6.987-9.792s-3.128-9.792-6.987-9.792H315.254c-3.859,0-6.987,4.384-6.987,9.792S311.4,358.41,315.254,358.41Z",
    transform: "translate(-267.026 -123.39)",
    fill: "#d6d6e3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M575.456,258.3h350.4a1.394,1.394,0,0,0,0-2.787h-350.4a1.394,1.394,0,0,0,0,2.787Z",
    transform: "translate(356.113 -91.704)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.166,
    cy: 8.348,
    rx: 8.166,
    ry: 8.348,
    transform: "translate(986.626 140)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.166,
    cy: 8.348,
    rx: 8.166,
    ry: 8.348,
    transform: "translate(958.415 140)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.166,
    cy: 8.348,
    rx: 8.166,
    ry: 8.348,
    transform: "translate(930.207 140)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.285,239.583,339.969,360.3a26.47,26.47,0,0,0,23.1,33.8l38.537,3.373Z",
    transform: "translate(298.108 352.502)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.285,239.583,339.969,360.3a26.47,26.47,0,0,0,23.1,33.8l38.537,3.373Z",
    transform: "translate(298.108 352.502)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.13,180.787l-47.239,78.124-22.242-28.179,43.469-68.057c-1.544-7.918.326-17.108,5.852-25.045,9.67-13.887,26.825-18.657,38.317-10.655s12.971,25.747,3.3,39.634c-5.526,7.937-13.5,12.879-21.459,14.178Z",
    transform: "translate(166.807 389.028)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.181,483.036l-5.673,19.293.192,19.563s-37.311,44.876-23.565,141.941l174.823-2.192-20.825-156.19L415.181,483.036Z",
    transform: "translate(284.248 276.167)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.5,70.913a49.577,49.577,0,1,1,64.431,47.311l-7.392,5.955,13.27,46.446L513.35,181.564l-48.859-40.716s10.555-13.444,16.216-28.6a49.523,49.523,0,0,1-22.2-41.331Z",
    transform: "translate(260.604 420.934)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.811,199.9c-17.5-.267-49.861,55.9-49.861,55.9l-26.579-9.4-54.665-19.353-41.9-17.243.184,1.266c-.165-.4-.344-.8-.542-1.2-4.4-9.076-17.2-19.753-53.521-17.637l-17.1,13.5-2.326,1.849a52.75,52.75,0,0,0-21.546,3.356c-7.779,3.127-15.559,8.962-19.239,19.868-1.907,5.625-1.907,17.256-.763,32.033,4.138,53.5,23.421,167.241,23.421,167.241l121.736-16.115,8.981.21s1.068-12.26,2.021-28.315c.591-9.419,1.125-20.116,1.43-30.412.21-7.551.267-14.872.133-21.317-.019-.4-.019-.8-.038-1.2-.362-11.764-1.544-20.287-4.08-21.221,0,0,7.875-.21,19.239-.629,27.457-1.03,75.315-3.337,82.141-7.055,9.648-5.244,60.233-75.62,60.233-75.62s-9.839-28.219-27.361-28.505Z",
    transform: "translate(283.283 367.433)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.68,67.883c-3.745-18.322-5.541-27.707-19.154-40.668-3.231.457.853,17.211-16.956,40.548-25.889,33.925-23.308,2.82-30.964,13.27-1.662,2.269-2.021,10.454-1.474,13.27,2.158,11.127,14.93.262,1.474,38.336-2,2.961-4.362,2.241-7.372,2.212-.233,0,1.294-.294-4.423-1.474-2.729-.564-6.548-1.229-11.127-2-53.192-8.961-71.974-76.078-30.86-111,9.354-7.945,18.535-13.966,26.505-16.756,24.007-8.4,78.7-2.941,89.205,24.329a83.52,83.52,0,0,1,5.147,39.931Z",
    transform: "translate(280.048 427.624)",
    fill: "#010102"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.937,
    cy: 37.937,
    rx: 37.937,
    ry: 37.937,
    transform: "translate(672.236 527.37)",
    fill: "#010102"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawSignHereLxua);
export default __webpack_public_path__ + "static/media/undraw_sign-here_lxua.f088863badbb31d6f98aa3065d160c7d.svg";
export { ForwardRef as ReactComponent };